var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-loading',{staticClass:"loading-el",attrs:{"type":"spinner","vertical":""}},[_vm._v(" "+_vm._s(_vm.msg)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }